import { useParams, Navigate } from "react-router-dom";
import Gallery from "@/components/Gallery";
import { getCollectionBySlug } from "@/data/photos";
import { useLang } from "@/context/LangContext";

function CollectionPage() {
  const { slug } = useParams();
  const { lang } = useLang();
  const collection = getCollectionBySlug(slug);
  if (!collection) return <Navigate to="/" replace />;
  const isEn = lang === "en";
  return (
    <Gallery
      photos={collection.photos}
      kicker={`${collection.number} — ${isEn ? "Collection" : "Collezione"}`}
      title={isEn ? collection.titleEn : collection.titleIt}
      subtitle={isEn ? collection.subtitleEn : collection.subtitleIt}
      testId={`grid-${collection.slug}`}
    />
  );
}

export default CollectionPage;
